"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONRPCProvider = void 0;
var types_1 = require("../types");
var services_1 = require("../../services");
var utility_1 = require("../utility");
var endpoints_1 = require("../endpoints");
var errors_utility_1 = require("../utility/errors.utility");
/**
 * Provider based on JSON-RPC HTTP requests
 */
var JSONRPCProvider = /** @class */ (function () {
    /**
     * Creates a new instance of the JSON-RPC Provider
     * @param {string} baseURL the JSON-RPC URL of the node
     */
    function JSONRPCProvider(baseURL) {
        this.baseURL = baseURL;
    }
    JSONRPCProvider.prototype.estimateGas = function (tx) {
        return Promise.reject('not supported');
    };
    JSONRPCProvider.prototype.getBalance = function (address, denomination, height) {
        return __awaiter(this, void 0, void 0, function () {
            var abciResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.ABCIEndpoint.ABCI_QUERY, [
                                "bank/balances/".concat(address),
                                '',
                                '0',
                                false,
                            ]),
                        })];
                    case 1:
                        abciResponse = _a.sent();
                        return [2 /*return*/, (0, utility_1.extractBalanceFromResponse)(abciResponse.response.ResponseBase.Data, denomination ? denomination : 'ugnot')];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getBlock = function (height) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.BlockEndpoint.BLOCK, [height.toString()]),
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getBlockResult = function (height) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.BlockEndpoint.BLOCK_RESULTS, [height.toString()]),
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getBlockNumber = function () {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStatus()];
                    case 1:
                        status = _a.sent();
                        return [2 /*return*/, parseInt(status.sync_info.latest_block_height)];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getConsensusParams = function (height) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.ConsensusEndpoint.CONSENSUS_PARAMS, [
                                height.toString(),
                            ]),
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getGasPrice = function () {
        return Promise.reject('not supported');
    };
    JSONRPCProvider.prototype.getNetwork = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.ConsensusEndpoint.NET_INFO),
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getAccountSequence = function (address, height) {
        return __awaiter(this, void 0, void 0, function () {
            var abciResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.ABCIEndpoint.ABCI_QUERY, [
                                "auth/accounts/".concat(address),
                                '',
                                '0',
                                false,
                            ]),
                        })];
                    case 1:
                        abciResponse = _a.sent();
                        return [2 /*return*/, (0, utility_1.extractSequenceFromResponse)(abciResponse.response.ResponseBase.Data)];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getAccountNumber = function (address, height) {
        return __awaiter(this, void 0, void 0, function () {
            var abciResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.ABCIEndpoint.ABCI_QUERY, [
                                "auth/accounts/".concat(address),
                                '',
                                '0',
                                false,
                            ]),
                        })];
                    case 1:
                        abciResponse = _a.sent();
                        return [2 /*return*/, (0, utility_1.extractAccountNumberFromResponse)(abciResponse.response.ResponseBase.Data)];
                }
            });
        });
    };
    JSONRPCProvider.prototype.getStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: (0, utility_1.newRequest)(endpoints_1.CommonEndpoint.STATUS),
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JSONRPCProvider.prototype.sendTransaction = function (tx, endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = (0, utility_1.newRequest)(endpoint, [tx]);
                switch (endpoint) {
                    case endpoints_1.TransactionEndpoint.BROADCAST_TX_COMMIT:
                        // The endpoint is a commit broadcast
                        // (it waits for the transaction to be committed) to the chain before returning
                        return [2 /*return*/, this.broadcastTxCommit(request)];
                    case endpoints_1.TransactionEndpoint.BROADCAST_TX_SYNC:
                    default:
                        return [2 /*return*/, this.broadcastTxSync(request)];
                }
                return [2 /*return*/];
            });
        });
    };
    JSONRPCProvider.prototype.broadcastTxSync = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response, errType, log;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: request,
                        })];
                    case 1:
                        response = _a.sent();
                        // Check if there is an immediate tx-broadcast error
                        // (originating from basic transaction checks like CheckTx)
                        if (response.error) {
                            errType = response.error[types_1.ABCIErrorKey];
                            log = response.Log;
                            throw (0, errors_utility_1.constructRequestError)(errType, log);
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    JSONRPCProvider.prototype.broadcastTxCommit = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response, check_tx, deliver_tx, errType, log, errType, log;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, services_1.RestService.post(this.baseURL, {
                            request: request,
                        })];
                    case 1:
                        response = _a.sent();
                        check_tx = response.check_tx, deliver_tx = response.deliver_tx;
                        // Check if there is an immediate tx-broadcast error (in CheckTx)
                        if (check_tx.ResponseBase.Error) {
                            errType = check_tx.ResponseBase.Error[types_1.ABCIErrorKey];
                            log = check_tx.ResponseBase.Log;
                            throw (0, errors_utility_1.constructRequestError)(errType, log);
                        }
                        // Check if there is a parsing error with the transaction (in DeliverTx)
                        if (deliver_tx.ResponseBase.Error) {
                            errType = deliver_tx.ResponseBase.Error[types_1.ABCIErrorKey];
                            log = deliver_tx.ResponseBase.Log;
                            throw (0, errors_utility_1.constructRequestError)(errType, log);
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    JSONRPCProvider.prototype.waitForTransaction = function (hash, fromHeight, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, utility_1.waitForTransaction)(this, hash, fromHeight, timeout)];
            });
        });
    };
    return JSONRPCProvider;
}());
exports.JSONRPCProvider = JSONRPCProvider;
